import { Dispatch, SetStateAction } from "react";
import { motion } from "framer-motion";
import clsx from "clsx";

type LangButtonProps = {
  currentLang: "fa" | "en";
  setCurrentLang: Dispatch<SetStateAction<"fa" | "en">>;
  bgColor?: "white" | "grayCustom";
  disabled?: boolean;
  onLocaleChange?: (locale: "fa" | "en") => void;
  className?: string;
};

const colorSchemes = {
  white: {
    containerBg: "bg-white",
    sliderBg: "bg-pinkCustom",
    text: "text-white",
  },
  grayCustom: {
    containerBg: "bg-grayCustom",
    sliderBg: "bg-pinkCustom",
    text: "text-white",
  },
};

export default function LangButton({
  currentLang,
  setCurrentLang,
  bgColor = "white",
  disabled = false,
  className,
  onLocaleChange,
}: LangButtonProps) {
  const colors = colorSchemes[bgColor];

  const handleChange = (locale: "fa" | "en") => {
    if (disabled || locale === currentLang) return;
    setCurrentLang(locale);
    onLocaleChange?.(locale);
  };

  return (
    <div
      className={clsx(
        "relative flex h-[34px] w-[86px] cursor-pointer overflow-hidden rounded-sm",
        colors.containerBg,
        className,
      )}
    >
      <motion.div
        layout
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
        className={clsx(
          "absolute bottom-[3px] z-0 h-[27px] w-[31px] rounded-sm",
          colors.sliderBg,
        )}
        style={{
          left: currentLang === "en" ? "6px" : "50px",
        }}
      />
      <button
        type="button"
        onClick={() => handleChange("en")}
        disabled={disabled}
        className={clsx(
          "z-10 mt-[3px] w-1/2 font-light transition disabled:cursor-not-allowed disabled:opacity-60",
          colors.text,
        )}
      >
        <span
          className={clsx(
            currentLang === "fa" && "text-slateCustom",
            "text-base font-semibold",
          )}
        >
          EN
        </span>
      </button>
      <span className="absolute left-1/2 top-[9px] h-[15px] w-px bg-gray-300"></span>
      <button
        type="button"
        onClick={() => handleChange("fa")}
        disabled={disabled}
        className={clsx(
          "z-10 mt-[3px] w-1/2 font-light transition disabled:cursor-not-allowed disabled:opacity-60",
          colors.text,
        )}
      >
        <span
          className={clsx(
            currentLang === "en" && "text-slateCustom",
            "block translate-x-px text-base font-semibold",
          )}
        >
          فا
        </span>
      </button>
    </div>
  );
}
